module.exports = __webpack_public_path__ + "img/envision1.53f3dd9b.jpg";